import { Checkbox, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { addTaskColumnCheckedItem, deleteTaskColumnCheckedItem } from 'app/actions/map';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

const MapTaskViewMenu = (props) => {
  const dispatch = useDispatch();
  const { taskColumnCheckedItems } = useSelector((state) => state.map);
  const { open, onClose, anchorEl } = props;

  const handleItemClick = (value) =>
    dispatch(taskColumnCheckedItems.indexOf(value) !== -1 ? deleteTaskColumnCheckedItem(value) : addTaskColumnCheckedItem(value));

  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      PaperProps={{
        sx: (theme) => ({
          marginTop: theme.spacing(1.5),
          '&:before': {
            right: '10px',
          },
        }),
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      sx={(theme) => ({
        '.MuiListItemIcon-root': {
          minWidth: '26px!important',
        },
        '.MuiCheckbox-root': {
          padding: theme.spacing(0),
          marginLeft: theme.spacing(0),
          svg: {
            fontSize: '18px',
          },
        },
      })}>
      {config.mapTaskColumns.map((value, key) => (
        <MenuItem key={key} disableRipple onClick={() => handleItemClick(value.name)}>
          <ListItemIcon>
            <Checkbox size='small' edge='start' tabIndex={-1} disableRipple checked={taskColumnCheckedItems.indexOf(value.name) !== -1} />
          </ListItemIcon>
          <ListItemText>{value.label}</ListItemText>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default MapTaskViewMenu;
